const indexSearchConstructor = function () {
    const indexList = document.querySelectorAll('.index-list');
    
    indexList.forEach((item) => {
        const indexEntry = item.querySelectorAll('a');

        indexEntry.forEach((link) => {
            const linkListItem = link.closest('li');

            linkListItem.setAttribute('data-entry-id', camelize(link.innerText.replace(/[^a-z0-9]/gi, ' ')));
            linkListItem.setAttribute('data-entry-title', link.innerText);
        })
    });

    let indexSearchTermsTitle = [];
    let indexSearchTermsID = [];

    function renderDataArrays(title) {
        indexSearchTermsTitle = [];
        indexSearchTermsID = [];
        
        document.querySelectorAll('[data-entry-id]').forEach((item) => {
            const titleText = item.getAttribute('data-entry-title').trim();

            indexSearchTermsTitle.push(titleText);
            indexSearchTermsID.push(item.getAttribute('data-entry-id'));
        });

        if (title !== null) {
            return indexSearchTermsTitle;
        }
    }

    const searchInputElement = document.querySelector('#indexSearchInput');
    const siteContentElement = document.querySelector('.site-content');
    const indexSearchElement = document.querySelector('.index-search');
    const indexResultsElement = document.querySelector('.index-results');
    const entrySections = siteContentElement.querySelectorAll('.index-section');
    const instructionsTextElement = siteContentElement.querySelector('.index-search__instruction-text');
    const instructionsText = instructionsTextElement.innerText;
    let entries;
    let autoCompleteList;
    let visibleEntries;
    let activeEntry;
    let parentItem;

    const autoCompleteJS = new autoComplete({
        selector: "#indexSearchInput",
        placeHolder: searchInputElement.getAttribute('placeholder'),
        threshold: 3,
        data: {
            src: renderDataArrays(true),
            cache: true,
        },
        resultItem: {
            highlight: true,
        },
        resultsList: {
            maxResults: 100000,
        },
        events: {
            input: {
                focus() {
                    if (autoCompleteJS.input.value.length) {
                        autoCompleteJS.start();
                    }
                },
                keyup() {
                    entries = indexSearchElement.querySelectorAll('li');
                    autoCompleteList = indexSearchElement.querySelector('[role="listbox"]');
                    visibleEntries = siteContentElement.querySelectorAll('.js-entry-showing');
                    
                    // Add/remove class to site content div if there's visible entries
                    if (autoCompleteList.getAttribute('hidden') !== null) {
                        siteContentElement.classList.remove('js-index-entries-showing');
                    } else {
                        siteContentElement.classList.add('js-index-entries-showing');
                    }

                    // Remove class from visible entries
                    visibleEntries.forEach((item) => {
                        item.classList.remove('js-entry-showing');
                    });

                    // Add visible class to found entries
                    entries.forEach((item) => {
                        activeEntry = siteContentElement.querySelector('[data-entry-id="' + camelize(item.innerText.replace(/[^a-z0-9]/gi, ' ')) + '"]');
                        activeEntry.classList.add('js-entry-showing');

                        parentItem = activeEntry.parentElement.closest('li');

                        if (parentItem) {
                            parentItem.classList.add('js-entry-showing');
                        }
                    });

                    // Add remove class from alpha section(s) with visible entries
                    entrySections.forEach((item) => {
                        if (item.querySelector('li.js-entry-showing')) {
                            item.classList.add('js-section-showing');
                        } else {
                            item.classList.remove('js-section-showing');
                        }
                    });

                    if (autoCompleteJS.input.value.length > 2 && siteContentElement.querySelectorAll('.js-section-showing').length === 0) {
                        instructionsTextElement.innerText = 'No results found.';
                        indexResultsElement.classList.add('js-index-section-hidden');
                    } else {
                        instructionsTextElement.innerText = instructionsText;
                        indexResultsElement.classList.remove('js-index-section-hidden');
                    }

                    if (autoCompleteJS.input.value.length < 3) {
                        siteContentElement.classList.remove('js-search-loader-showing');
                    }
                },
            },
        },
    });

    let typingLoaderInterval = null;

    searchInputElement.addEventListener('input', () => {
        clearInterval(typingLoaderInterval);
    });

    searchInputElement.addEventListener('results', () => {
        siteContentElement.classList.add('js-search-loader-showing');
        typingLoaderInterval = setInterval(() => {
            siteContentElement.classList.remove('js-search-loader-showing');
        }, 500);
    });

    function camelize(str) {
        return str.replace(/(?:^\w|[A-Z]|\b\w|\s+)/g, function(match, index) {
        if (+match === 0) return '';
            return index === 0 ? match.toLowerCase() : match.toUpperCase();
        });
    }
}

window.addEventListener('DOMContentLoaded', indexSearchConstructor);